import React from "react";
import Select from "react-select";

export const AddressStep = ({
  formData,
  errors,
  countries,
  onChange,
  onCountryChange,
}) => (
  <React.Fragment>
    <div className="grid-item">
      <Select
        classNamePrefix="country-select"
        options={countries}
        value={countries.find((country) => country.value === formData.country) || null}
        onChange={onCountryChange}
        placeholder="Country *"
        isClearable
      />
      {errors.country && <p className="error-text">{errors.country}</p>}
    </div>
    <div className="grid-item">
      <input
        name="state"
        placeholder="State"
        value={formData.state}
        onChange={onChange}
      />
    </div>
    <div className="grid-item">
      <input
        name="city"
        placeholder="City *"
        value={formData.city}
        onChange={onChange}
        required
      />
    </div>
    <div className="grid-item">
      <input
        name="pincode"
        placeholder="Pincode *"
        value={formData.pincode}
        onChange={onChange}
        required
      />
    </div>
    <div className="grid-item grid-item--full">
      <input
        name="address"
        placeholder="Address *"
        value={formData.address}
        onChange={onChange}
        required
      />
    </div>
  </React.Fragment>
);
